import React from 'react'
import * as Styled from './styled'

interface ListHeaderProps {
  header: string | string[]
}

const UPGRADE_LIST_HEADER = 'upgrade-listheader'

const ListHeader: React.FC<ListHeaderProps> = ({ header }) => (
  <>
    {Array.isArray(header) ? (
      <Styled.ListHeaderWrapper data-test={UPGRADE_LIST_HEADER}>
        {header.map((item) => (
          <Styled.ListMultiHeader>{item}</Styled.ListMultiHeader>
        ))}
      </Styled.ListHeaderWrapper>
    ) : (
      <Styled.ListHeader data-test={UPGRADE_LIST_HEADER}>{header}</Styled.ListHeader>
    )}
  </>
)

export default ListHeader
